import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import { MultiTextFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";

export const ZoneCodesFilter: ISourcingToolSearchFilter = {
  id: "zone-codes-id",
  type: "multi-text-search",
  field: "sidebar.react.search_sidebar.zone_codes",
  mustOptions: [MultiTextFilterMust.MATCH_ALL, MultiTextFilterMust.MATCH_NONE],
  must: MultiTextFilterMust.MATCH_ALL,
  mustIsConfigurable: true,
  updateFilterDialogIsVisible: false,
  searchTags: [],
  // searchTagsAutoCompleteConfig: {
  //   basePath: `${ENVIRONMENT.MCSEARCH_SERVICE_URL}/autocomplete/{type}/{limit}/{searchText}`,
  //   variables: {
  //     type: `zone_codes_tags`,
  //     limit: 5,
  //   },
  //   searchVariableName: "searchText",
  // },
  searchTypes: [SearchType.SOURCING_TOOL_US_FL],
};
